import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '../views/Home.vue'
// import Index from '../views/Index.vue'
// import UserCenter from '../views/UserCenter.vue'
import Login from "../views/Login.vue";
import axios from "../axios";
import store from "../store";

// replace
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // component: Home,
    component: () => import("@/views/Home.vue"),
    children: [
      {
        path: "/index",
        name: "Index",
        meta: {
          title: "首页"
        },
        // component: Index
        component: () => import("@/views/Index.vue")
      },
      {
        path: "/userCenter",
        name: "UserCenter",
        meta: {
          title: "个人中心"
        },
        component: () => import("@/views/UserCenter.vue")
        // component: UserCenter
      }
    ]
  },
  {
    path: "/measure-result",
    name: "MeasureResultForHR",
    meta: { title: "测量结果" },
    component: () => import("@/views/data/MeasureResult.vue")
  },
  {
    path: "/login",
    name: "Login",
    // component: () => import('@/views/Login.vue')
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let hasRoute = store.state.menus.hasRoutes;
  let token = localStorage.getItem("token");

  if (to.path === "/login") {
    return next();
  }

  // HR嵌入页白名单：无token也可进入，后续通过postMessage注入token
  // if (to.path === "/hr/measure-result") {
  //   return next();
  // }

  if (!token) {
    return next({ path: "/login" });
  }

  if (token && !hasRoute) {
    axios
      .get("/api/sys/menu/nav", {
        headers: { token: localStorage.getItem("token") }
      })
      .then(res => {
        store.commit("setMenuList", res.data.data.nav);
        store.commit("setPermList", res.data.data.authoritys);

        hasRoute = true;
        store.commit("changeRouteStatus", true);

        let newRoutes = router.options.routes;
        res.data.data.nav.forEach(menu => {
          if (menu.children) {
            menu.children.forEach(e => {
              let route = menuToRoute(e);
              if (route) {
                newRoutes[0].children.push(route);
              }
            });
          }
        });
        router.addRoute(newRoutes[0]);
        next({ ...to, replace: true });
      })
      .catch(() => {
        next({ path: "/login" });
      });
    return;
  }

  next();
});

// 导航转成路由
const menuToRoute = menu => {
  if (!menu.component) {
    return null;
  }

  let route = {
    path: menu.path,
    name: menu.name,
    meta: {
      icon: menu.icon,
      title: menu.title
    }
  };
  route.component = () =>
    import("@/views/" + menu.component + ".vue").catch(() =>
      import("@/views/Index.vue")
    );

  // console.log(route)

  return route;
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js